import React from "react";
import { Checkbox } from "antd";

const CheckboxFilter = ({ addFilter, currentFilters }) => {
  const onChange = e => {
    addFilter(e.target.checked);
  };
  return (
    <Checkbox
      checked={currentFilters}
      onChange={v => {
        onChange(v);
      }}
    >
      Secto only
    </Checkbox>
  );
};

export default CheckboxFilter;



// WEBPACK FOOTER //
// src/components/filter/Checkbox.filter.js